import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/card.png'
import _imports_1 from '@/assets/images/card@2x.png'


const _hoisted_1 = _imports_1 + ' 2x'
const _hoisted_2 = { class: "tip" }
const _hoisted_3 = { class: "img" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    isDisabled: _ctx.isDisabled,
    prePathName: "transfer-step",
    current: 3,
    btnText: "下一步，转账",
    form: _ctx.form
  }, {
    default: _withCtx(() => [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "page-title" }, [
        _createElementVNode("img", {
          src: _imports_0,
          srcset: _hoisted_1,
          alt: ""
        }),
        _createElementVNode("p", null, [
          _createElementVNode("span", null, "绑定香港银行卡"),
          _createElementVNode("span", { class: "setp" }, "1/3")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _cache[11] || (_cache[11] = _createTextVNode(" 为了资金进出安全，请绑定与您证件同名")),
        _createElementVNode("span", null, _toDisplayString(_ctx.nameConvertFunc), 1),
        _cache[12] || (_cache[12] = _createTextVNode("的香港 银行账户，用以进行身份核实。 "))
      ]),
      _createVNode(_component_van_cell_group, {
        title: "银行名称",
        border: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_field, {
            name: "bank",
            modelValue: _ctx.form.bankName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.bankName) = $event)),
            rules: [{ required: true, message: '请选择银行' }],
            readonly: "",
            placeholder: "请选择银行",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showBankPickerToggle(true))),
            "right-icon": "arrow-down"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_van_popup, {
            show: _ctx.showBankPicker,
            "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showBankPicker) = $event)),
            round: "",
            position: "bottom"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_picker, {
                title: "请选择",
                columns: _ctx.bankOptions,
                onConfirm: _ctx.onBankConfirm,
                onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showBankPickerToggle(false)))
              }, null, 8, ["columns", "onConfirm"])
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }),
      (_ctx.form.bankName === '其他银行')
        ? (_openBlock(), _createBlock(_component_van_cell_group, {
            key: 0,
            title: "注明银行名称",
            border: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                name: "account",
                rules: [{ required: true, message: '请输入银行名称' }],
                modelValue: _ctx.form.otherBankName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.otherBankName) = $event)),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_van_cell_group, {
        title: "银行账户",
        border: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_field, {
            name: "account",
            rules: [{ required: true, message: '请输入银行账户' }],
            modelValue: _ctx.form.bankNo,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.bankNo) = $event)),
            placeholder: "请输入银行账户"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "account-type" }, "账户类型", -1)),
      _createVNode(_component_van_field, {
        name: "accountType",
        rules: [{ required: true, message: '请选择账户类型' }]
      }, {
        input: _withCtx(() => [
          _createVNode(_component_van_checkbox_group, {
            modelValue: _ctx.form.moneyType,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.moneyType) = $event)),
            direction: "vertical",
            class: "bank-checkbox-type"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moneyOptions, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_checkbox, {
                  name: item.value,
                  key: index,
                  shape: "quare"
                }, {
                  icon: _withCtx((props) => [
                    _createElementVNode("i", {
                      class: _normalizeClass(
                  `iconfont ${props.checked ? 'icon-duoxuanxuanzhong' : 'icon-duoxuanweixuanzhong'}`
                )
                    }, null, 2)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "tips" }, [
        _createElementVNode("div", null, "账户凭证可上传银行卡、银行结单或开户资料"),
        _createElementVNode("div", { class: "note" }, "请注意：某些香港银行提款卡上印有的并非银行账户号码，只是提款卡号码")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_field, {
          name: "uploader",
          rules: [{ required: true, message: '请上传凭证' }]
        }, {
          input: _withCtx(() => [
            _createVNode(_component_van_uploader, {
              modelValue: _ctx.fileList,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.fileList) = $event)),
              "before-read": _ctx.beforeRead,
              accept: ".pdf,image/*",
              "max-count": "5",
              "preview-size": "86",
              readonly: _ctx.isApp,
              deletable: false
            }, {
              "preview-cover": _withCtx((file) => [
                _createElementVNode("div", {
                  class: "preview-cover",
                  onClick: _withModifiers(($event: any) => (_ctx.handleDel(file)), ["stop"])
                }, _cache[13] || (_cache[13] = [
                  _createElementVNode("i", { class: "iconfont icon-cangpeitubiao_shanchu" }, null, -1)
                ]), 8, _hoisted_4)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "upload-style",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.uploadToApp && _ctx.uploadToApp(...args)))
                }, _cache[14] || (_cache[14] = [
                  _createElementVNode("i", { class: "iconfont icon-jia-tianchong" }, null, -1),
                  _createElementVNode("p", null, "上传凭证", -1)
                ]))
              ]),
              _: 1
            }, 8, ["modelValue", "before-read", "readonly"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("p", {
        class: "sample",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.viewExp && _ctx.viewExp(...args)))
      }, "查看正确示例"),
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "condition" }, [
        _createElementVNode("p", null, "凭证需包含："),
        _createElementVNode("p", null, "1.客户姓名"),
        _createElementVNode("p", null, "2.银行账户"),
        _createElementVNode("p", null, "3.银行名称")
      ], -1)),
      _createVNode(_component_van_action_sheet, {
        show: _ctx.fileActionState,
        "onUpdate:show": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.fileActionState) = $event)),
        actions: _ctx.actionsList,
        "cancel-text": "取消",
        "close-on-click-action": "",
        onSelect: _ctx.onFileSelect
      }, null, 8, ["show", "actions", "onSelect"])
    ]),
    _: 1
  }, 8, ["onHandleNext", "isDisabled", "form"]))
}